import { render, staticRenderFns } from "./CategoryUpdate.vue?vue&type=template&id=bb3e4c48&"
import script from "../../../services/admin/category/category-update.js?vue&type=script&lang=js&"
export * from "../../../services/admin/category/category-update.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports